"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.driversLicense = void 0;
const enums_1 = require("@bemlo/enums");
exports.driversLicense = {
    [enums_1.DriversLicense.MANUAL]: 'Körkort för manuellt växlad bil',
    [enums_1.DriversLicense.AUTOMATIC]: 'Körkort för automatväxlad bil',
    [enums_1.DriversLicense.NONE]: 'Inget körkort',
};
